import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'

export const salesRouter: RouteRecordRaw[] = [
  {
    // Legacy per-brand sales page. Selling now lives entirely in the admin
    // sales dashboard, so this path only survives as a redirect for old
    // bookmarks — it lands on the brand's dashboard (Locations tab).
    meta: {
      authZ: ({ user }) => user.hasRole('pb:super'),
      title: 'sales.dashboard',
    },
    name: 'brand.sales',
    path: 'sales',
    redirect: (to: RouteLocationNormalized) => ({
      name: 'admin.sales.brand',
      params: { brandId: to.params.brandId },
    }),
  },
]
